import { AppBar, Toolbar, Typography } from '@material-ui/core'
import { css } from 'emotion'
import React from 'react'
import styled from 'react-emotion'

import { PageTitle } from '../atoms/PageTitle'

interface IProps {
  title: string
}

const grow = css`
  flex-grow: 1;
`

const MainTitle = styled(Typography)`
  margin-right: 2rem;
`

export const TopBar: React.SFC<IProps> = ({ title }) => (
  <div className={grow}>
    <AppBar position="static">
      <Toolbar>
        <MainTitle variant="h5" color="inherit">
          <PageTitle>{title}</PageTitle>
        </MainTitle>
        <Typography variant="overline" color="inherit" className={grow}>
          Shopify Gateway Manager
        </Typography>
      </Toolbar>
    </AppBar>
  </div>
)
